class Types {
  isArray(object) {
    return Array.isArray(object);
  }
  isDate(object) {
    return object instanceof Date;
  }
  isRegexp(object) {
    return object instanceof RegExp;
  }
  isString(object) {
    return typeof object === "string";
  }
  isNumber(object) {
    return typeof object === "number";
  }
  isBoolean(object) {
    return typeof object === "boolean";
  }
  isFunction(object) {
    return typeof object === "function";
  }
  isFloat(object) {
    return object === +object;
  }
  isInt(object) {
    return Number.isInteger(object);
  }
  isObject(object) {
    return typeof object === "object" && object !== null && !this.isArray(object);
  }
  isMap(object) {
    return object instanceof Map;
  }
  isSet(object) {
    return object instanceof Set;
  }
  isTraversable(object) {
    return typeof object === "object";
  }
  isPrimitive(object) {
    return typeof object !== "object" && typeof object !== "function";
  }
  isPromise(object) {
    return object && this.isFunction(object.then);
  }
  isNumeric(object) {
    return typeof object === "string" && object.length > 0 && !Number.isNaN(Number(object));
  }
  isDefined(object) {
    return !(object === null || object === undefined);
  }
  isEntity(object) {
    const hasNamespace = Boolean(Object.getOwnPropertyDescriptor(object, "namespace"));
    return object && this.isObject(object) && hasNamespace && object.namespace;
  }
}

const types = new Types();
export { Types, types };